import { SectionLayout } from "layouts";
import { Trans } from "react-i18next";

const styles = {
  quoteMark: "text-[30px] text-[#04A9F4]",
};

export const CustomerTestimonial = () => {
  return (
    <SectionLayout
      separatorProps={{
        variant: "offset",
      }}
      className="bg-grey"
      heading={
        <Trans i18nKey="mhealth-studio.customer-testimonial.heading">
          Customer <strong>testimonial</strong>
        </Trans>
      }
    >
      <div className="grid gap-4 max-w-lg mx-auto text-center text-[25px]">
        <blockquote>
          <span className={styles.quoteMark}>"</span>I have just finished
          running a test and it works perfectly! The new version of mHealth is
          quick and easy-to-use. Congrats to all in your team!
          <span className={styles.quoteMark}>"</span>
        </blockquote>
        <div className="font-bold uppercase">
          <div className="text-[25px] text-[#04A9F4] italic">
            Raphael zakine
          </div>
          <div className="text-[15px]">Director audiome</div>
        </div>
      </div>
    </SectionLayout>
  );
};
